// modules
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { addModal } from 'weblite-web-modal-viewer'
// component
import { OutDatedBrowser } from './out-dated-browser'

const COMPONENT_ID = 'browserOutDated'

export const showOutDatedBrowser = () => addModal({ id: COMPONENT_ID })

export default {
  [COMPONENT_ID]: {
    Component: OutDatedBrowser,
  },
}
